import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor() {}

  handleObservableError<T>() {
    return (error: any): Observable<T> => {
      console.log('ErrorService.handleObservableError', error);
      let errorMessage = this.getErrorMessage(error);
      return throwError(() => errorMessage);
    };
  }

  getErrorMessage(error: any) {
    console.log('ErrorService.getErrorMessage', error);
    let errorMessage = 'An error occurred';

    if (error instanceof HttpErrorResponse) {
      // Server or connection error
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        // Backend error
        const msg = error.error?.error || error.error?.message || error.message;
        errorMessage = `${error.status} ${error.statusText}: ${msg}`;
      }
    } else if (error instanceof Error) {
      errorMessage = error.message;
    }

    return errorMessage;
  }
}
